<template>
    <div>
        <v-layout wrap row justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Peligros y fuentes de peligro
                    identificados en el monitoreo de atmósferas</h1>
                <p><span class="instruccion">Haz clic sobre las tarjetas para conocer la información y en los botones para avanzar entre tarjetas.</span></p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-center">
                <div class="cont-pq">
                    <v-card color="transparent" flat tile>
                        <v-window v-model="onboarding">
                            <v-window-item v-for="n in length" :key="`card-${n}`" height="200">
                                <v-card class="cont_text-slider" color="transparent" flat>
                                    <div class="flip-card" :class="{ flipped: isFlipped[n] }" @click="toggleFlip(n)">
                                        <div class="flip-card-inner">
                                            <div class="flip-card-front">
                                                <div class="slider-cont--img animated flipInY">
                                                    <v-card class="cont_text-slider" color="#ffd757" flat style="cursor: pointer;">
                                                        <div class="cont-card-flip">
                                                            <h1 style="margin-top: 20px;text-transform: uppercase;">{{
                            complemento[onboarding].title }}</h1>
                                                            <img :src="require('@/assets/unidad1/pantalla-6-' + complemento[onboarding].img1 + '.png')"
                                                                alt="" height="150"
                                                                style="width: auto; margin-bottom: 25px;">
                                                            <img :src="require('@/assets/unidad1/pantalla-6-' + complemento[onboarding].img2 + '.png')"
                                                                alt="" height="60" style="width: auto;">
                                                            <h4 style="margin-top: 10px;">{{
                            complemento[onboarding].subtitle }}</h4>
                                                        </div>
                                                    </v-card>
                                                </div>
                                            </div>
                                            <div class="flip-card-back">
                                                <v-card class="cont_text-slider-1" color="#ffd757" flat>
                                                    <div style="text-align: left; padding: 20px;" v-html="complemento[onboarding].list"></div>
                                                </v-card>
                                            </div>
                                        </div>
                                    </div>
                                </v-card>
                            </v-window-item>
                        </v-window>
                    </v-card>
                    <v-card-actions class="cont_buttons-slider">
                        <v-item-group light v-model="onboarding" class="text-center " mandatory>
                            <v-item v-for="n in length" :key="`btn-${n}`" v-slot:default="{ active, toggle }">
                                <v-btn :color="vistosSlide[n - 1] ? '#FFAF50' : '#28F7D1'" small class="item-button"
                                    :input-value="active" icon @click="toggle">
                                    <v-icon>mdi-record</v-icon>
                                </v-btn>
                            </v-item>
                        </v-item-group>
                    </v-card-actions>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import nextConditions from "../../js/mixins/nextConditions";
import svgmod1 from "./svg/mod6-1"
export default {
    components: {
        svgmod1,
    },
    mixins: [nextConditions],
    data() {
        return {
            vistos: Array(3).fill(false),
            isFlipped: [false, false, false],
            vistosSlide: [true, false, false],
            onboarding: 0,
            length: 3,
            complemento: [
                {
                    title: 'PELIGRO DE EXPLOSIÓN',
                    img1: '1-1',
                    img2: '1-2',
                    subtitle: 'Gas inflamable / Comburente',
                    list: '<ul><li>Para evitar una explosión, los niveles atmosféricos deben mantenerse por debajo del <b>límite inferior de explosividad</b> (LEL) para cada gas, o disminución en la concentración de oxígeno.</li><li>Generalmente <b>medido en un rango de 0-100%</b> del límite inferior de explosividad (LEL) o en parte por millón (ppm).</li><li>Los equipos para monitoreo de atmósferas diseñados para alarmar antes de que ocurra una <b>posible condición de atmósfera explosiva.</b></li></ul>'
                },
                {
                    title: 'Peligro para la salud humana',
                    img1: '2-1',
                    img2: '2-2',
                    subtitle: 'Gases tóxicos / Irritantes',
                    list: '<ul><li>Normalmente se mide en el rango de partes por millón(ppm).</li><li>Los equipos para monitoreo de gases tóxicos están diseñados <b>para alertar a los trabajadores</b> antes de que el nivel de gas alcance una concentración nociva para la salud.</li><li>Algunos equipos para monitoreo pueden <b>calcular la explosión promedio a lo largo del tiempo</b>, proporcionando un límite de exposición a corto plazo (STEL) y ponderado en el tiempo (TWA).</li></ul>'
                }, {
                    title: 'Peligro por deficiencia de oxígeno',
                    img1: '3-1',
                    img2: '3-2',
                    subtitle: 'Oxígeno',
                    list: '<ul><li>Las atmósferas que contienen muy poco oxígeno (menos del 19,5% del oxígeno por volumen) se consideran “difíciles en oxígeno” e <b>interfieren con respiración normal humana.</b></li><li>Las atmósferas que contienen demasiado oxígeno (más del 23,5% de oxígeno por volumen) se consideran “enriquecidas con oxígeno” y <b>poseen mayor riesgo de explosión.</b></li><li>Medido en porcentaje de volumen (el porcentaje normal de oxígeno en el aire es de 20,8% por volumen al nivel del mar).</li><li>Los equipos para monitoreo de oxígeno generalmente están configurados para <b>alarmar si la atmósfera contiene demasiado o muy poco oxígeno.</b></li></ul>'
                }
            ]
        }
    },
    methods: {
        toggleFlip(index) {
            this.$set(this.isFlipped, index, !this.isFlipped[index]);
            this.$set(this.vistos, index - 1, true)
        },
    },
    mounted() {
        this.$set(this.vistos, 0, true)
        setTimeout(() => {
            this.$store.commit('nextShow', false)
        }, 3000);
    },
    watch: {
        onboarding(val) {
            this.$set(this.vistosSlide, val, true)
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../sass/globals';

.icon-titulo {
    content: url('../../assets/imagenes_compartidas/icon-titulo.png');
    align-items: center;
    justify-content: start;
    width: 15px;
    height: 15px;
}

ol {
    list-style: none;
    counter-reset: my-awesome-counter;
    padding-left: 10px;
}

ol li {
    counter-increment: my-awesome-counter;
    display: flex;
    align-items: center;
    justify-content: start;

    span {
        margin: 0.5em;
        padding: 0.5em;
        border-left: 2px solid $color-complement-one;
    }
}

ol li::before {
    content: counter(my-awesome-counter) ". ";
    color: $color-primary;
    font-weight: bold;
    margin-right: 0.01em;
}

li {}

.container-module {
    text-align: left;

    p {
        margin: 0;
        padding: 0;
    }

    img {
        width: 80px;
        display: inline-block;
        vertical-align: middle;
    }

    .modulo-name {
        display: inline-block;
        vertical-align: middle;
        width: 80%;
        text-align: left;
        padding-left: 10px;
    }

    @media screen and (max-width: 500px) {
        text-align: center;

        img {
            width: 40%;
        }

        .modulo-name {
            width: 100%;
            padding-left: 0px;
        }
    }
}

.pantalla {
    @media screen and (max-width: 600px) {
        display: none;
    }
}

.mobile {
    @media screen and (min-width: 600px) {
        display: none;
    }

    @media screen and (max-width: 600px) {
        display: block;
    }
}

.cont-pq {
    width: 60%;
    margin: 0 auto;

    @media screen and (max-width: 330px) {
        width: 100%;
    }
}

.cont_buttons-slider-1 {
    justify-content: center;

    .item-button {
        width: 15px;
        height: 15px;
    }
}


.cont-pq {
    width: 60%;
    margin: 0 auto;

    @media screen and (max-width: 330px) {
        width: 100%;
    }
}

.btn-img--wb {
    width: 120px;
}

.cont_buttons-slider {
    justify-content: center;

    .item-button {
        width: 15px;
        height: 15px;
    }
}

.flip-item {
    position: relative;
    width: 100%;
    height: auto;
    padding: 10px;

    p {
        text-align: center;
        margin: 0;
        padding: 0;
    }

    @media screen and (max-width: 330px) {
        img {
            width: 150px;
        }
    }
}

.slider-cont--img {
    margin: 0 auto;
    min-width: 200px;
    min-height: 212px;

    img {
        width: 40%;
    }

    @media screen and (max-width: 1650px) {
        min-width: 100% !important;
        min-height: 100px;

        img {
            width: 70%;
        }
    }

    @media screen and (max-width: 950px) {
        min-width: 100% !important;
        min-height: 100px;

        img {
            width: 100%;
        }
    }
}

.flip-card {
    perspective: 1000px;
    width: 100%;
    height: 400px;
}

.flip-card-inner {
    position: relative;
    width: 100%;
    height: 400px;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;
}

.flipped .flip-card-inner {
    transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
    position: absolute;
    height: 400px;
    width: 100%;
    backface-visibility: hidden;
}

.flip-card-front {
    background-color: transparent;
}

.flip-card-back {
    background-color: #f8f8f8;
    transform: rotateY(180deg);
}

.cont_text-slider {
    margin-bottom: 20px;
    height: 400px;
}

.cont_text-slider-1 {
    margin-bottom: 20px;
    height: 400px;
}

.cont-card-flip {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>